/** Ink-and-wash still lifes — keyed by English category slug (before "||" in DB title). */
export const CATEGORY_IMAGE_BY_SLUG: Record<string, string> = {
  accessories: '/catalog/catalog-accessories.webp?v=white',
  apparel: '/catalog/catalog-apparel.webp?v=white',
  bags: '/catalog/catalog-bags.webp?v=white',
  eatable: '/catalog/catalog-eatable.webp?v=white',
  electronics: '/catalog/catalog-electronics.webp?v=white',
  expo: '/catalog/catalog-events.webp?v=white',
  home: '/catalog/catalog-home.webp?v=white',
  mugs: '/catalog/catalog-mugs.webp?v=white',
  office: '/catalog/catalog-office.webp?v=white',
  pens: '/catalog/catalog-pens.webp?v=white',
  safety: '/catalog/catalog-safety.webp?v=white',
  sport: '/catalog/catalog-sport.webp?v=white',
  toys: '/catalog/catalog-toys.webp?v=white',
  umbrellas: '/catalog/catalog-umbrellas.webp?v=white',
}

const DEFAULT_IMAGE = '/catalog/catalog-apparel.webp?v=white'

const TITLE_TO_SLUG: Record<string, string> = {
  accessories: 'accessories',
  apparel: 'apparel',
  bags: 'bags',
  eatable: 'eatable',
  electronics: 'electronics',
  'expo & events': 'expo',
  'home & living': 'home',
  mugs: 'mugs',
  office: 'office',
  pens: 'pens',
  safety: 'safety',
  'sport & leisure': 'sport',
  'toys & games': 'toys',
  umbrellas: 'umbrellas',
}

export const getCategoryImageUrl = (title: string): string => {
  const english = (title.split('||')[0] ?? title).trim().toLowerCase()
  const slug = TITLE_TO_SLUG[english]
  if (slug && CATEGORY_IMAGE_BY_SLUG[slug]) {
    return CATEGORY_IMAGE_BY_SLUG[slug]
  }
  return DEFAULT_IMAGE
}

/** English slug for a DB category title (e.g. `Apparel || Kläder` → `apparel`). */
export const getCategorySlugFromTitle = (title: string): string | null => {
  const english = (title.split('||')[0] ?? title).trim().toLowerCase()
  if (!english) return null
  return TITLE_TO_SLUG[english] ?? english
}
